export default __webpack_public_path__ + "btn-save.png?24bfbff1e0eeed39793152df3e9f7ae8";